<template>
    <div class="annt-accounting-entity-wrapper">
        <el-dropdown class="lang-seletor" trigger="click" v-if="entityListOptions.length > 0">
            <!-- <el-button type="text" icon="el-icon-suitcase-1">{{ currentEntityName }}</el-button> -->
            <el-button type="text" class="accounting-entity-btn">
                <i class="icon iconfont icon-zuhuqiehuanicon"></i>
                <span class="entity-name">{{ currentEntityName || '请选择会计主体' }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
                <el-dropdown-menu class="doc-dropdown">
                    <el-dropdown-item
                        @click="toSwitchEntity(item)"
                        v-for="item in entityListOptions"
                        :key="item.entityCode"
                        :command="item.entityCode">
                        {{ item.entityShortName }}
                        <i v-if="item.entityCode === currentEntity.entityCode" class="el-icon-check"></i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
<script>
import { computed, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { switchOwner } from '@/api/login.js'
import { getCargoOwnerInfo, setToken, setCargoOwnerInfo } from '@/utils/auth'

export default {
    name: 'AccountingEntitySelector',
    setup() {
        const store = useStore()

        const state = reactive({
            switching: false,
        })

        /** 会计主体选项列表 */
        const entityListOptions = computed(() => {
            return store.getters.entityList || []
        })

        /** 当前会计主体-对象 */
        const currentEntity = computed(() => {
            return store.getters.accountingEntity
        })

        /** 当前会计主体名称 */
        const currentEntityName = computed(() => {
            return currentEntity.value?.entityShortName
        })

        /** 切换会计主体 */
        const toSwitchEntity = item => {
            if (state.switching) return
            if (item.entityCode === currentEntity.value?.entityCode) return
            state.switching = true

            // 获取当前货主信息
            const cargoOwnerInfo = JSON.parse(getCargoOwnerInfo() || '[]')
            const currentOwner = cargoOwnerInfo.find(owner => owner.flag === 0)

            if (!currentOwner) {
                state.switching = false
                return
            }

            // 构建请求参数，增加 entityCode 字段
            const params = {
                ...currentOwner,
                mobile: store.state.user.user.contactsMobile,
                entityCode: item.entityCode,
            }

            switchOwner(params)
                .then(res => {
                    state.switching = false
                    if (res && +res.code === 0) {
                        setToken(res.data.token)

                        // 更新货主列表中的会计主体
                        for (const key in cargoOwnerInfo) {
                            if (cargoOwnerInfo[key].anhzCode === currentOwner.anhzCode) {
                                cargoOwnerInfo[key].flag = 0
                            } else {
                                cargoOwnerInfo[key].flag = null
                            }
                        }
                        setCargoOwnerInfo(JSON.stringify(cargoOwnerInfo))

                        // 更新 store 中的会计主体
                        store.commit('updateAccountingEntity', item)

                        // 刷新页面
                        window.location.reload()
                    }
                })
                .catch(() => {
                    state.switching = false
                })
        }

        return {
            ...toRefs(state),
            entityListOptions,
            currentEntity,
            currentEntityName,
            toSwitchEntity,
            store,
        }
    },
}
</script>
<style lang="less">
.annt-accounting-entity-wrapper {
    .accounting-entity-btn {
        display: flex;
        align-items: center;
        padding: 0;
        height: 100%;
        font-size: 12px;
        color: #333;

        &:hover {
            color: #409eff;
        }

        i {
            margin-right: 4px;
            font-size: 12px;
        }

        .entity-name {
            margin: 0;
            font-weight: bold;
        }
    }
}

.doc-dropdown {
    padding: 8px 0;

    li {
        padding: 4px 16px;
    }
}
</style>
